/**
 * 앱의 '공유받은 사진' 통로를 찾는 자리.
 *
 * 이 통로는 **1.0.43 에서 처음 생겼다.** 그보다 옛 앱에서도 웹은 최신이라
 * 입구가 보이고 /collect 로 들어올 수 있는데, 거기엔 대답해 줄 앱이 없다.
 * 그 상태를 **빨리, 그리고 확실히** 가려내는 것이 여기 있는 이유다.
 *
 * 왜 기다려야 하나
 * ---------------
 * 앱은 핸들러를 페이지가 다 뜬 뒤(onPageFinished) 하나씩 주입한다. 그래서
 * 화면이 그려진 직후에는 최신 앱에서도 아직 없을 수 있다 — 한 번 보고 없다고
 * 단정하면 멀쩡한 앱을 구버전으로 몰아낸다.
 *
 * 왜 5초를 다 기다릴 필요는 없나
 * -----------------------------
 * 주입은 한 묶음으로 일어난다(webview_page.dart onPageFinished). 그러니
 * **옛날부터 있던 통로**가 보이는데 사진 통로만 없으면, 주입은 이미 끝났고
 * 이 앱에는 그 기능이 없는 것이다. 그때는 더 기다릴 이유가 없다.
 *
 * 다만 주입은 한 줄씩 들어오므로 둘 사이에 아주 짧은 틈이 있다. 표시를 본
 * 즉시가 아니라 GRACE_MS 를 더 보고 판정한다 — 5초가 1초 아래로 줄고,
 * 그 틈에 걸려 최신 앱을 잘못 내치는 일도 없다.
 */

/** 앱이 핸들러를 주입할 때까지 기다리는 최대 시간 */
export const BRIDGE_WAIT_MS = 5000
export const BRIDGE_POLL_MS = 100

/** 옛 통로를 본 뒤 사진 통로를 더 기다려 주는 시간 */
export const GRACE_MS = 800

export const bridge = (): any => (window as any).FlutterBridge

/** 사진 통로가 깔렸나 (1.0.43+) */
export const hasSharedPhotos = (b: any): boolean =>
  !!b && typeof b.getSharedPhotos === 'function'

/**
 * 주입이 이미 끝났다는 표시.
 *
 * 오래전부터 있던 통로들만 본다 — 이것이 보이는데 사진 통로가 없으면
 * '아직 안 깔린 것'이 아니라 '이 빌드엔 없는 것'이다.
 * 사진 통로보다 **나중에** 깔리는 것은 쓰지 않는다(틈이 길어진다).
 */
export const injectionDone = (b: any): boolean =>
  !!b &&
  (typeof b.requestLocationPermission === 'function' ||
    typeof b.openGallery === 'function')

/**
 * 'checking' 은 아직 모르는 상태다. 화면은 이때 **아무것도 단정하지 않아야**
 * 한다 — 입구를 보여주지도, 없다고 말하지도 않는다.
 */
export type SharedPhotosSupport = 'checking' | 'ready' | 'unsupported'
